export const GOOGLE_PAY_INIT_READY_TO_PAY = 'GOOGLE_PAY_INIT_READY_TO_PAY'
export const GOOGLE_PAY_READY_TO_PAY_SUCCESS = 'GOOGLE_PAY_READY_TO_PAY_SUCCESS'
export const GOOGLE_PAY_READY_TO_PAY_FAILURE = 'GOOGLE_PAY_READY_TO_PAY_FAILURE'
